import React from 'react';
import { makeStyles, Typography, colors, Divider, Box } from '@material-ui/core';
import { injectIntl } from 'react-intl';
import { ReactComponent as IconEmoji } from 'assets/svgs/emoji.svg';
import ServicePage from 'pages/Applications';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  emptyWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    flex: 1,
    padding: theme.spacing(6)
  },
  emoji: {
    width: 65,
    height: 65,
    marginBottom: theme.spacing(1)
  },
  emptyTitle: {
    margin: theme.spacing(1, 0)
  },
}));

const PermissionsInfo = ({
  intl: { formatMessage },
  apaves,
  data: { services: permissions },
}) => {
  const classes = useStyles();
  const activated_apaves = apaves.filter(service => (permissions || []).find(item => item.allowed && item.appId == service.appId))

  return (
    <div>
      {
        activated_apaves.length <= 0 &&
        <>
          <Box className={classes.emptyWrap}>
            <IconEmoji className={classes.emoji} />
            <Typography variant='h3' className={classes.emptyTitle}>
              <strong>{formatMessage({ id: "profile.service.emptyTitle" })}</strong>
            </Typography>
            <Typography className={classes.emptyDesp}>
              {formatMessage({ id: "profile.service.emptyDesp" })}
            </Typography>
          </Box>
          <Divider />
          <br />
        </>
      }
      <ServicePage
        disablePadding
        hideBookmark
        title={formatMessage({ id: "profile.service.title" })}
        hideSubtitle
        searchPlaceholder={formatMessage({ id: "profile.service.search" })}
      />
    </div >
  );
};
PermissionsInfo.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }),
  apaves: PropTypes.any,
  data: PropTypes.shape({
    services: PropTypes.any
  }),
};
export default injectIntl(PermissionsInfo);
